/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CrunchyrollNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAClElEQVR4nMVVOWhUURT9UTDihopLoSAoCMZCUREURVCig/Pv8qNv7v2TkSlsFBGXxkYYIZVgUFERtLKwMJ2ICygpXabRIoUiIkbcEKPiRtx5M38mbyaz/EmhF37z7vv33HPOfe953v+MZNLMA5JDwNqPLK+B5Bey/kDSV0h6BQPdEwSZOS0XJspOR5YzQDqMrH8afUD6CUh6jDFT4nUdpJYB69OaxVgHgfUmsNxA0jyQfnByD5llSZPO08uRZaiysLwFkiNbu9ILqvcbY8ZDoBuRtA9ZfwPJG0TTUbvzZHrGqM5JLvl+OCsOc5/DNcj6DEgfIeLUURuA5HRV50c9z2sr5S19IO0tSFOUahBZbwHpfgCda/ckjJmNLAPIcqyiuE0AyfeRzrWvnEsk2i14NEE1TJZzrsFB0D3fgtuaTve615mKd3aKIo0nWFPrThHpNZdlWS6SHciyr7xgqTo/Hh5Zl+ONRtSnkOtY0gakJ1yAx6Wfkl3phZHmi4D0ZyMAIllfz3RgzbgAX6KpeeKY3tPskLlsq4M5vdL1oHBird5OB/3NAeSjH6RWuIWt4T7JJuufAyDPIwbXy6xIH8RgYIfiK5CcBZKdlpFVAUlPVekll4sM5L6zdjcOQB3Q3kqAIrpNDHd2ZiZHAOfHCmDHtALAFrV3TuRDaNd8ls1jAiD5VjrZ1TLtjg5PPpfLjbMfkNxrHaBK/1IUCrJcjTbuKhiNpgNY3scHkIGSxDUjkeiehiS3LU2fw3XFeQ5XA8nLGJ3n7QvoNQvf9ycB6wVk+Vy6CowxM4HkZC02wPICWQ5uyGYneq0EUWoLkt4B1ovMsrjIMNGOqKsQdbtP4TYAXVrrsmspbBFEPWB9IZK1sd/efxV/AZHzO7Z2kEaiAAAAAElFTkSuQmCC)
 */
export const CrunchyrollNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.94 22.7a11.02 11.02 0 0 1-8.86-6.08A10.08 10.08 0 0 1 1 11.85c0-1.79.33-3.22 1.08-4.75a10.96 10.96 0 0 1 8.52-6.05c.8-.1 2.51-.07 3.27.07 1.57.28 2.98.84 4.24 1.69a10.8 10.8 0 0 1 4.86 9.64c-.03.06-.05 0-.07-.28a9.65 9.65 0 0 0-19.01-.88 9.25 9.25 0 0 0 .3 4.84 9.62 9.62 0 0 0 8.1 6.48c.67.05.5.1-.33.1-.46 0-.92-.02-1.02-.03Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.27 21.34a7.7 7.7 0 0 1-7.06-8.7 7.7 7.7 0 0 1 6.6-6.5c.7-.1 1.94-.07 2.6.07a8.2 8.2 0 0 1 1.74.56l.39.18-.37.18a3.47 3.47 0 0 0-1.96 3.5 3.5 3.5 0 0 0 5.98 1.96c.16-.16.3-.28.3-.26.02.02.05.24.09.5a7.67 7.67 0 0 1-8.3 8.51Z"
        className={colorClass}
      />
    </svg>
  );
};
